import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Menu, X } from "lucide-react";

import { assetsPrefix } from "../../utilities/utilities";
import { selectIsUserLoggedIn } from "../../redux/selectors";

const Header = ({ openRequestNoticeForm }) => {
  const navigate = useNavigate();
  const isUserLoggedIn = useSelector(selectIsUserLoggedIn);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    {
      label: "About Us",
      onClick: () => navigate("/about"),
    },
    {
      label: "Services",
      onClick: () => navigate("/services"),
    },
    {
      label: "Contact Us",
      onClick: () => navigate("/contact"),
    },
  ];

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 md:px-8">
        {/* Logo */}
        <button onClick={() => navigate("/")} className="flex items-center">
          <img
            src={`${assetsPrefix}/images/trueCounselLogo.png`}
            alt="TrueCounsel"
            className="h-10 w-auto object-contain"
          />
        </button>

        {/* Desktop Navigation */}
        <nav className="hidden items-center gap-8 md:flex">
          {isUserLoggedIn && (
            <button
              onClick={() => navigate("/app/choose_manager")}
              className="text-sm font-medium text-gray-700 transition hover:text-black"
            >
              App
            </button>
          )}

          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={item.onClick}
              className="text-sm font-medium text-gray-700 transition hover:text-black"
            >
              {item.label}
            </button>
          ))}

          <button
            onClick={openRequestNoticeForm}
            className="rounded-lg bg-black px-5 py-2 text-sm font-medium text-white transition hover:opacity-90"
          >
            Request Notice
          </button>

          {!isUserLoggedIn && (
            <button
              onClick={() => navigate("/login")}
              className="rounded-lg bg-black px-5 py-2 text-sm font-medium text-white transition hover:opacity-90"
            >
              Login
            </button>
          )}
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden"
          onClick={() => setIsMenuOpen((prev) => !prev)}
          aria-label="Toggle Menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="border-t bg-white md:hidden">
          <div className="flex flex-col p-4">
            {isUserLoggedIn && (
              <button
                onClick={() => {
                  navigate("/app");
                  setIsMenuOpen(false);
                }}
                className="py-3 text-left"
              >
                App
              </button>
            )}

            {!isUserLoggedIn && (
              <button
                onClick={() => {
                  navigate("/login");
                  setIsMenuOpen(false);
                }}
                className="py-3 text-left"
              >
                Login
              </button>
            )}

            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={() => {
                  item.onClick();
                  setIsMenuOpen(false);
                }}
                className="py-3 text-left"
              >
                {item.label}
              </button>
            ))}

            <button
              onClick={() => {
                openRequestNoticeForm();
                setIsMenuOpen(false);
              }}
              className="mt-4 rounded-lg bg-black px-4 py-3 text-white"
            >
              Request Notice
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
